import { NgModule } from '@angular/core';
import { PhxDividerComponent } from './phx-divider.component';

@NgModule({
  declarations: [
    PhxDividerComponent,
  ],
  exports: [
    PhxDividerComponent,
  ],
})
export class PhxDividerModule { }
